function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import linkaddressVue from '@/components/linkaddress';
import { pageTypeEnum } from '../components/js/enum';
export default {
  name: 'PageConfig',
  components: {
    linkaddressVue: linkaddressVue
  },
  data: function data() {
    return {
      pageTypeEnum: pageTypeEnum,
      form: {}
    };
  },
  watch: {
    '$route.query': {
      handler: function handler(newVal) {
        this.form = _objectSpread({}, newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    updateConfig: function updateConfig(prop) {
      this.$emit('updatePageConfig', {
        prop: prop,
        data: this.form[prop]
      });
    },
    changeBg: function changeBg(isShow, prop) {
      var _this$form;
      // debugger
      if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form[isShow])) return;
      this.$emit('updatePageConfig', {
        prop: prop,
        data: this.form[prop]
      });
    },
    updateBg: function updateBg(e, isShow, prop) {
      this.$emit('updatePageConfig', {
        prop: isShow,
        data: e
      });
      if (!e) return;
      this.$emit('updatePageConfig', {
        prop: prop,
        data: this.form[prop]
      });
    },
    uploadbgImg: function uploadbgImg(prop) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form, prop, data[0].sattDir);
      });
    },
    linkUrl: function linkUrl(url) {
      this.$set(this.form, 'advUrl', url);
    },
    openLink: function openLink() {
      this.$refs.linkaddressVueRef.dialogVisible = true;
    },
    initForm: function initForm(data) {
      this.form = _objectSpread(_objectSpread({}, this.form), data);
    },
    reset: function reset() {
      var _this$$route$query, _this$$route$query2;
      this.form = {
        type: Number((_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.type) || 3,
        miniAppId: Number((_this$$route$query2 = this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.miniAppId)
      };
    }
  }
};